import * as React from "react";
import Col from "reactstrap/lib/Col";
import { GoogleAnalyticsService } from "src/share/services/ga";

export interface IGARequestorProps {
  pagePath?: string;
  views: {
    query: {
      ids: string
    }
  }
  dimension: string;
  children: (data: any) => React.ReactNode;
}
export interface IGARequestorState {
  data: any[]
}
export class GARequestor extends React.PureComponent<IGARequestorProps, IGARequestorState> {
  public chartNode;
  public chart;

  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }
  public componentDidMount() {
    this.getData()
  }
  public componentDidUpdate(prevProps: IGARequestorProps) {
    if (this.props.views.query.ids !== prevProps.views.query.ids || this.props.pagePath !== prevProps.pagePath) {
      this.getData()
    }
  }
  public async getData() {
    const data = await GoogleAnalyticsService.getDimensionInfo(this.props.views.query.ids, this.props.dimension, this.props.pagePath)
    this.setState({ data })
  }
  public render() {
    return (
      <Col className="col-12 white-background">
        {this.props.children(this.state.data)}
      </Col>
    )
  }
}


// WEBPACK FOOTER //
// ./src/share/components/GoogleAnalitycs/GARequestor.tsx